const SysMsgDict = {
  //BTN
  BTN_Cancel: "BTN_Cancel",
  BTN_Login: "BTN_Login",
  BTN_Submit: "BTN_Submit",
  BTN_Confirm: "BTN_Confirm",
  BTN_Yes: "BTN_Yes",
  BTN_Finish: "BTN_Finish",
  BTN_Update: "BTN_Update",
  BTN_Delete: "BTN_Delete",
  BTN_Save: "BTN_Save",
  BTN_AutoGen: "BTN_AutoGen",
  BTN_Logout: "BTN_Logout",
  BTN_ChangePw: "BTN_ChangePw",
  BTN_Export: "BTN_Export",
  BTN_ChooseFile: "BTN_ChooseFile",
  BTN_SendEmail: "BTN_SendEmail",
  BTN_Ok: "BTN_Ok",
  BTN_Clear: "BTN_Clear",
  BTN_Invitation: "BTN_Invitation",
  BTN_History: "BTN_History",
  BTN_StartInterview: "BTN_StartInterview",
  BTN_UseExistingRecord: "BTN_UseExistingRecord",
  BTN_CreateNew: "BTN_CreateNew",
  BTN_ReSubmit: "BTN_ReSubmit",
  BTN_Ok: "BTN_Ok",
  BTN_ExportAutopay: "BTN_ExportAutopay",
  //LBL
  LBL_HolidayTypeALL:"LBL_HolidayTypeALL",
  LBL_DaysAdv: "LBL_DaysAdv",//假期
  LBL_PunchingMethod: "LBL_PunchingMethod",//打卡方式
  LBL_TakeCard: "LBL_TakeCard",//拍卡
  LBL_IsFromApp2: "LBL_IsFromApp2",//手机签到
  LBL_Leave: "LBL_Leave",
  LBL_RememberMe: "LBL_RememberMe",
  LBL_ForgetPassword: "LBL_ForgetPassword",
  LBL_Welcome: "LBL_Welcome",
  LBL_Approve: "LBL_Approve",
  LBL_Reject: "LBL_Reject",
  LBL_Pending: "LBL_Pending",
  LBL_Since: "LBL_Since",
  LBL_Days: "LBL_Days",
  LBL_Hours: "LBL_Hours",
  LBL_Local: "LBL_Local",
  LBL_Oversea: "LBL_Oversea",
  LBL_Event: "LBL_Event",
  LBL_Description: "LBL_Description",
  LBL_Type: "LBL_Type",
  LBL_Year: "LBL_Year",
  LBL_Location: "LBL_Location",
  LBL_WorkType: "LBL_WorkType",
  LBL_Time: "LBL_Time",
  LBL_Ref: "LBL_Ref",
  LBL_Date: "LBL_Date",
  LBL_From: "LBL_From",
  LBL_To: "LBL_To",
  LBL_FinishEvent: "LBL_FinishEvent",
  LBL_EventEngTitle: "LBL_EventEngTitle",
  LBL_Password: "LBL_Password",
  LBL_NewPassword: "LBL_NewPassword",
  LBL_ConfirmNewPw: "LBL_ConfirmNewPw",
  LBL_DeleteEvent: "LBL_DeleteEvent",
  LBL_Filter: "LBL_Filter",
  LBL_DateApplied: "LBL_DateApplied",
  LBL_DateApproved: "LBL_DateApproved",
  LBL_StartDay: "LBL_StartDay",
  LBL_TotalTime: "LBL_TotalTime",
  LBL_Remark: "LBL_Remark",
  LBL_Status: "LBL_Status",
  LBL_NewLeaveApp: "LBL_NewLeaveApp",
  LBL_StaffName: "LBL_StaffName",
  LBL_DaysOrHrs: "LBL_DaysOrHrs",
  LBL_DateEnd: "LBL_DateEnd",
  LBL_Staff: "LBL_Staff",
  LBL_Duration: "LBL_Duration",
  LBL_LeaveReason: "LBL_LeaveReason",
  LBL_ID: "LBL_ID",
  LBL_Action: "LBL_Action",
  LBL_JobTitle: "LBL_JobTitle",
  LBL_ExpectedInAbbr: "LBL_ExpectedInAbbr",
  LBL_ExpectedOutAbbr: "LBL_ExpectedOutAbbr",
  LBL_RejReason: "LBL_RejReason",
  LBL_ActInAbbr: "LBL_ActInAbbr",
  LBL_ActOutAbbr: "LBL_ActOutAbbr",
  LBL_WorkHrs: "LBL_WorkHrs",
  LBL_Allowance: "LBL_Allowance",
  LBL_LeaveType: "LBL_LeaveType",
  LBL_Adjustment: "LBL_Adjustment",
  LBL_Addition: "LBL_Addition",
  LBL_Claimed: "LBL_Claimed",
  LBL_Balance: "LBL_Balance",
  LBL_Month: "LBL_Month",
  LBL_UserGrp: "LBL_UserGrp",
  LBL_EngDesc: "LBL_EngDesc",
  LBL_ChiDesc: "LBL_ChiDesc",
  LBL_Add: "LBL_Add",
  LBL_UserProfile: "LBL_UserProfile",
  LBL_Username: "LBL_Username",
  LBL_Mobile: "LBL_Mobile",
  LBL_Email: "LBL_Email",
  LBL_StaffGrade: "LBL_StaffGrade",
  LBL_Supervisor: "LBL_Supervisor",
  LBL_Language: "LBL_Language",
  LBL_DateJoin: "LBL_DateJoin",
  LBL_DateResigned: "LBL_DateResigned",
  LBL_Delete: "LBL_Delete",
  LBL_UserGrpRights: "LBL_UserGrpRights",
  LBL_Create: "LBL_Create",
  LBL_Import: "LBL_Import",
  LBL_Print: "LBL_Print",
  LBL_Send: "LBL_Send",
  LBL_View: "LBL_View",
  LBL_Edit: "LBL_Edit",
  LBL_Permissions: "LBL_Permissions",
  LBL_AdvanceApplyDay: "AdvanceApplyDay",
  LBL_YearOfService: "LBL_YearOfService",
  LBL_Enquiry: "LBL_Enquiry",
  LBL_BalanceHistory: "LBL_BalanceHistory",
  LBL_Completed: "LBL_Completed",
  LBL_PlsEnterCompCode: "LBL_PlsEnterCompCode",
  LBL_Expired: "LBL_Expired",
  LBL_CheckIn: "LBL_CheckIn",
  LBL_CheckOut: "LBL_CheckOut",
  LBL_Reason: "LBL_Reason",
  LBL_SearchQuery: "LBL_SearchQuery",
  LBL_NoData: "LBL_NoData",
  LBL_Record: "LBL_Record",
  LBL_Acting: "LBL_Acting",
  LBL_DateAdded: "LBL_DateAdded",
  LBL_AddrIn: "LBL_AddrIn",
  LBL_AddrOut: "LBL_AddrOut",
  LBL_AMPM: "LBL_AMPM",
  LBL_AM: "LBL_AM",
  LBL_PM: "LBL_PM",
  LBL_HalfDay: "LBL_HalfDay",
  LBL_WorkPhone: "LBL_WorkPhone",
  LBL_UserChiname: "LBL_UserChiname",
  LBL_ProcBy: "LBL_ProcBy",
  LBL_EmpRef: "LBL_EmpRef",
  LBL_RejReason: "LBL_RejReason",
  LBL_ReceiveAllNotification: "LBL_ReceiveAllNotification",
  LBL_RosterBase: "LBL_RosterBase",
  LBL_IsFromApp: "LBL_IsFromApp",
  LBL_SkippedSun: "LBL_SkippedSun",
  LBL_SkippedSat: "LBL_SkippedSat",
  LBL_Approved: "LBL_Approved",
  LBL_CancelRejected: "LBL_CancelRejected",
  LBL_Pending: "LBL_Pending",
  LBL_Rejected: "LBL_Rejected",
  LBL_EmpType: "LBL_EmpType",
  LBL_Contract: "LBL_Contract",
  LBL_Probation: "LBL_Probation",
  LBL_NewEmployeeType: "LBL_NewEmployeeType",
  LBL_EditEmployeeType: "LBL_EditEmployeeType",
  LBL_JobCode: "LBL_JobCode",
  LBL_NewJobPosition: "LBL_NewJobPosition",
  LBL_EditJobPosition: "LBL_EditJobPosition",
  LBL_AcademicCode: "LBL_AcademicCode",
  LBL_SACode: "LBL_SACode",
  LBL_SpecReq: "LBL_SpecReq",
  LBL_NewSourceOfApp: "LBL_NewSourceOfApp",
  LBL_EditSourceOfApp: "LBL_EditSourceOfApp",
  LBL_NewAcademic: "LBL_NewAcademic",
  LBL_EditAcademic: "LBL_EditAcademic",
  LBL_PlanCode: "LBL_PlanCode",
  LBL_NewBenefit: "LBL_NewBenefit",
  LBL_EditBenefit: "LBL_EditBenefit",
  LBL_StaffGradeList: "LBL_StaffGradeList",
  LBL_TempCode: "LBL_TempCode",
  LBL_EditDocTemp: "LBL_EditDocTemp",
  LBL_NewDocTemp: "LBL_NewDocTemp",
  LBL_SysVarList: "LBL_SysVarList",
  LBL_SysVar: "LBL_SysVar",
  LBL_VarDesc: "LBL_VarDesc",
  LBL_DocContent: "LBL_DocContent",
  LBL_EName: "LBL_EName",
  LBL_CName: "LBL_CName",
  LBL_BankCode: "LBL_BankCode",
  LBL_EditBank: "LBL_EditBank",
  LBL_NewBank: "LBL_NewBank",
  LBL_Country: "LBL_Country",
  LBL_District: "LBL_District",
  LBL_Area: "LBL_Area",
  LBL_EditDistrict: "LBL_EditDistrict",
  LBL_NewDistrict: "LBL_NewDistrict",
  LBL_SkillCate: "LBL_SkillCate",
  LBL_Item: "LBL_Item",
  LBL_Seq: "LBL_Seq",
  LBL_AnsType: "LBL_AnsType",
  LBL_Option: "LBL_Option",
  LBL_DatePerReq: "LBL_DatePerReq",
  LBL_EditSkill: "LBL_EditSkill",
  LBL_NewSkill: "LBL_NewSkill",
  LBL_StaffList: "LBL_StaffList",
  LBL_BasicInformation: "LBL_BasicInformation",
  LBL_EngName: "LBL_EngName",
  LBL_LastName: "LBL_LastName",
  LBL_StaffBadge: "LBL_StaffBadge",
  LBL_ChiName: "LBL_ChiName",
  LBL_StaffType: "LBL_StaffType",
  LBL_Company: "LBL_Company",
  LBL_IDDoc: "LBL_IDDoc",
  LBL_IDNumber: "LBL_IDNumber",
  LBL_CardNo: "LBL_CardNo",
  LBL_Nationality: "LBL_Nationality",
  LBL_NameOfCardholder: "LBL_NameOfCardholder",
  LBL_DateofBirth: "LBL_DateofBirth",
  LBL_Address: "LBL_Address",
  LBL_AddressEng: "LBL_AddressEng",
  LBL_MarriedStatus: "LBL_MarriedStatus",
  LBL_DocNum: "LBL_DocNum",
  LBL_EmergencyContact: "LBL_EmergencyContact",
  LBL_Name: "LBL_Name",
  LBL_Contact: "LBL_Contact",
  LBL_Relationship: "LBL_Relationship",
  LBL_EmrgCont: "LBL_EmrgCont",
  LBL_SOACode: "LBL_SOACode",
  LBL_EmpFileNum: "LBL_EmpFileNum",
  LBL_Title: "LBL_Title",
  LBL_StartDate: "LBL_StartDate",
  LBL_DateProbatEnd: "LBL_DateProbatEnd",
  LBL_Grade: "LBL_Grade",
  LBL_Department: "LBL_Department",
  LBL_Team: "LBL_Team",
  LBL_ResetLeave: "LBL_ResetLeave",
  LBL_DateTerm: "LBL_DateTerm",
  LBL_DateLastWork: "LBL_DateLastWork",
  LBL_JobCodeList: "LBL_JobCodeList",
  LBL_History: "LBL_History",
  LBL_Clear: "LBL_Clear",
  LBL_Salary: "LBL_Salary",
  LBL_SalaryNum: "LBL_SalaryNum",
  LBL_BenefitPlan: "LBL_BenefitPlan",
  LBL_BenefitList: "LBL_BenefitList",
  LBL_Benefit: "LBL_Benefit",
  LBL_Academic: "LBL_Academic",
  LBL_InstituteName: "LBL_InstituteName",
  LBL_FromDate: "LBL_FromDate",
  LBL_ToDate: "LBL_ToDate",
  LBL_Type: "LBL_Type",
  LBL_Firm: "LBL_Firm",
  LBL_JoinPosition: "LBL_JoinPosition",
  LBL_LastPosition: "LBL_LastPosition",
  LBL_ReasonLeave: "LBL_ReasonLeave",
  LBL_JobAdCode: "LBL_JobAdCode",
  LBL_CompanyCode: "LBL_CompanyCode",
  LBL_Interviewer: "LBL_Interviewer",
  LBL_Closed: "LBL_Closed",
  LBL_ClosedAds: "LBL_ClosedAds",
  LBL_NotClosedAds: "LBL_NotClosedAds",
  LBL_UserList: "LBL_UserList",
  LBL_DOB: "LBL_DOB",
  LBL_DateApply: "LBL_DateApply",
  LBL_CandidatesName: "LBL_CandidatesName",
  LBL_Contact: "LBL_Contact",
  LBL_InterviewDate: "LBL_InterviewDate",
  LBL_InterviewTime: "LBL_InterviewTime",
  LBL_Confirmed: "LBL_Confirmed",
  LBL_AppliedJob: "LBL_AppliedJob",
  LBL_DateOfBirth: "LBL_DateOfBirth",
  LBL_ProposeInterviewSchedule: "LBL_ProposeInterviewSchedule",
  LBL_Attachment: "LBL_Attachment",
  LBL_Keyword: "LBL_Keyword",
  LBL_Remark: "LBL_Remark",
  LBL_CandidateFound: "LBL_CandidateFound",
  LBL_Cancelled: "LBL_Cancelled",
  LBL_CancelReason: "LBL_CancelReason",
  LBL_SelectDate: "LBL_SelectDate",
  LBL_Candidates: "LBL_Candidates",
  LBL_ApplyFor: "LBL_ApplyFor",
  LBL_SearchCandidate: "LBL_SearchCandidate",
  LBL_AppliedPosition: "LBL_AppliedPosition",
  LBL_Result: "LBL_Result",
  LBL_EnterPassword: "LBL_EnterPassword",
  LBL_InterviewerMsg: "LBL_InterviewerMsg",
  LBL_Information: "LBL_Information",
  LBL_Criteria: "LBL_Criteria",
  LBL_Observation: "LBL_Observation",
  LBL_Average: "LBL_Average",
  LBL_Recommandation: "LBL_Recommandation",
  LBL_Offer: "LBL_Offer",
  LBL_Position: "LBL_Position",
  LBL_Commencement: "LBL_Commencement",
  LBL_BasicSalary: "LBL_BasicSalary",
  LBL_Allowance: "LBL_Allowance",
  LBL_Previous: "LBL_Previous",
  LBL_AttachmentLetter: "LBL_AttachmentLetter",
  LBL_Step: "LBL_Step",
  LBL_JobHistory: "LBL_JobHistory",
  LBL_START: "LBL_START",
  LBL_Candidate: "LBL_Candidate",
  LBL_Personal: "LBL_Personal",
  LBL_SelectPosition: "LBL_SelectPosition",
  LBL_FinishSubmit: "LBL_FinishSubmit",
  LBL_DateExpExist: "LBL_DateExpExist",
  LBL_Tel: "LBL_Tel",
  LBL_Next: "LBL_Next",
  LBL_Gender: "LBL_Gender",
  LBL_Interview: "LBL_Interview",
  LBL_CallMe: "LBL_CallMe",
  LBL_And: "LBL_And",
  LBL_CompDate: "LBL_CompDate",
  LBL_Post: "LBL_Post",
  LBL_MakeOffer: "LBL_MakeOffer",
  LBL_FinalApprover: "LBL_FinalApprover",
  LBL_Job: "LBL_Job",
  LBL_OfferedBy: "LBL_OfferedBy",
  LBL_JobOfferSearch: "LBL_JobOfferSearch",
  LBL_CandidatesFollow: "LBL_CandidatesFollow",
  LBL_DoneBy: "LBL_DoneBy",
  LBL_OfferResult: "LBL_OfferResult",
  LBL_MakeOfferDate: "LBL_MakeOfferDate",
  LBL_MakeOfferBy: "LBL_MakeOfferBy",
  LBL_SignContract: "LBL_SignContract",
  LBL_ReferenceCheck: "LBL_ReferenceCheck",
  LBL_DataEntry: "LBL_DataEntry",
  LBL_DataVerification: "LBL_DataVerification",
  LBL_RejectLog: "LBL_RejectLog",
  LBL_InterviewBy: "LBL_InterviewBy",
  LBL_Letter: "LBL_Letter",
  LBL_IssueBy: "LBL_IssueBy",
  LBL_Content: "LBL_Content",
  LBL_Template: "LBL_Template",
  LBL_LetterDetail: "LBL_LetterDetail",
  LBL_Terminate: "LBL_Terminate",
  LBL_CurrentSalary: "LBL_CurrentSalary",
  LBL_ProbationStatus: "LBL_ProbationStatus",
  LBL_AppraisalPeriod: "LBL_AppraisalPeriod",
  LBL_DateEffective: "LBL_DateEffective",
  LBL_Extension: "LBL_Extension",
  LBL_ExtensionMonth: "LBL_ExtensionMonth",
  LBL_RatingList: "LBL_RatingList",
  LBL_NextRatingDate: "LBL_NextRatingDate",
  LBL_RatingFrom: "LBL_RatingFrom",
  LBL_JobAds: "LBL_JobAds",
  LBL_InviteCandidate: "LBL_InviteCandidate",
  LBL_JobApplicationForm: "LBL_JobApplicationForm",
  LBL_SearchStaff: "LBL_SearchStaff",
  LBL_IncludeStaff: "LBL_IncludeStaff",
  LBL_SalPayCycle: "LBL_SalPayCycle",
  LBL_AnotherInterviewSch: "LBL_AnotherInterviewSch",
  LBL_AnotherInterviewTime: "LBL_AnotherInterviewTime",
  LBL_ValidateCandidate: "LBL_ValidateCandidate",
  LBL_Cancelled: "LBL_Cancelled",
  LBL_CancelReason: "LBL_CancelReason",
  LBL_Attachment: "LBL_Attachment",
  LBL_SelectAll: "LBL_SelectAll",
  LBL_SyncMessage: "LBL_SyncMessage",
  LBL_NotSynced: "LBL_NotSynced",
  LBL_Synced: "LBL_Synced",
  LBL_SyncError: "LBL_SyncError",
  LBL_EditCompany: "LBL_EditCompany",
  LBL_NewCompany: "LBL_NewCompany",
  LBL_CompCode: "LBL_CompCode",
  LBL_EditDocType: "LBL_EditDocType",
  LBL_NewDocType: "LBL_NewDocType",
  LBL_DocTypeCode: "LBL_DocTypeCode",
  LBL_IncludeResignUser: "LBL_IncludeResignUser",
  LBL_Resigned: "LBL_Resigned",
  LBL_Calendar: "LBL_Calendar",
  LBL_Active: "LBL_Active",
  LBL_ProposeInterviewSchedule: "LBL_ProposeInterviewSchedule",
  LBL_CancelledLeavePending: "LBL_CancelledLeavePending",
  LBL_CancelledLeaveApproved: "LBL_CancelledLeaveApproved",
  LBL_CancelledLeaveReject: "LBL_CancelledLeaveReject",
  LBL_CancelLeaveApplication: "LBL_CancelLeaveApplication",
  LBL_Group: "LBL_Group",
  LBL_Assess: "LBL_Assess",
  LBL_NotApprove: "LBL_NotApprove",
  LBL_Color: "LBL_Color",
  LBL_LateSubmitLegend: "LBL_LateSubmitLegend",
  LBL_LateSubmit: "LBL_LateSubmit",
  LBL_Major: "LBL_Major",
  LBL_ShiftCode: "LBL_ShiftCode",
  LBL_Description: "LBL_Description",
  LBL_TimeFrom: "LBL_TimeFrom",
  LBL_TimeTo: "LBL_TimeTo",
  LBL_StaffID: "LBL_StaffID",
  LBL_DateWork: "LBL_DateWork",
  LBL_CheckAttendance: "LBL_CheckAttendance",
  LBL_ShiftType: "LBL_ShiftType",
  LBL_Roster: "LBL_Roster",
  LBL_LocCode: "LBL_LocCode",
  LBL_ParentLoc: "LBL_ParentLoc",
  LBL_NFCTag: "LBL_NFCTag",
  LBL_InLoc: "LBL_InLoc",
  LBL_OutLoc: "LBL_OutLoc",
  LBL_IsNeedUpload: "LBL_IsNeedUpload",
  LBL_DocStatus: "LBL_DocStatus",
  LBL_NotNeedSubmit: "LBL_NotNeedSubmit",
  LBL_AttachmentStatus: "LBL_AttachmentStatus",
  LBL_DateTx: "LBL_DateTx",
  LBL_Download: "LBL_Download",
  LBL_NightShiftJob: "LBL_NightShiftJob",
  LBL_NextDay: "LBL_NextDay",
  LBL_PayProfile: "LBL_PayProfile",
  LBL_PayGroup: "LBL_PayGroup",
  LBL_PayType: "LBL_PayType",
  LBL_PayMethod: "LBL_PayMethod",
  LBL_YOS: "LBL_YOS",
  LBL_PayRate: "LBL_PayRate",
  LBL_VCR: "LBL_VCR",
  LBL_VCE: "LBL_VCE",
  LBL_PayGroupDesc: "LBL_PayGroupDesc",
  LBL_PayrollStartDay: "LBL_PayrollStartDay",
  LBL_PayrollDefaultDay: "LBL_PayrollDefaultDay",
  LBL_ExpAutopayFile: "LBL_ExpAutopayFile",
  LBL_AC: "LBL_AC",
  LBL_BankFileType: "LBL_BankFileType",
  LBL_Payroll: "LBL_Payroll",
  LBL_PayrollTrial: "LBL_PayrollTrial",
  LBL_LastApprovalOrRejectMsg: "LBL_LastApprovalOrRejectMsg",
  LBL_Total: "LBL_Total",
  LBL_Deduct: "LBL_Deduct",
  LBL_Number: "LBL_Number",
  LBL_Rate: "LBL_Rate",
  LBL_MPF: "LBL_MPF",
  LBL_MPFr: "LBL_MPFr",
  LBL_MPFe: "LBL_MPFe",
  LBL_Net: "LBL_Net",
  LBL_ApprovalOrRejectMsg: "LBL_ApprovalOrRejectMsg",
  LBL_Leavebalasoftoday: "LBL_Leavebalasoftoday",
  LBL_PayrollAdjustment: "LBL_PayrollAdjustment",
  LBL_Particular: "LBL_Particular",
  LBL_Amount: "LBL_Amount",
  LBL_Src: "LBL_Src",
  LBL_SpecialPayment: "LBL_SpecialPayment",
  LBL_DatePay: "LBL_DatePay",
  LBL_BankAutopay: "LBL_BankAutopay",
  LBL_Cumulation: "LBL_Cumulation",
  LBL_Approval: "LBL_Approval",
  LBL_Msg: "LBL_Msg",
  LBL_ApproveBy: "LBL_ApproveBy",
  LBL_SyncfromGov: "LBL_SyncfromGov",
  LBL_PayAdj: "LBL_PayAdj",
  LBL_New: "LBL_New",
  LBL_Released: "LBL_Released",
  LBL_FinalPayment: "LBL_FinalPayment",
  LBL_DailyWage: "LBL_DailyWage",
  LBL_AL: "LBL_AL",
  LBL_CL: "LBL_CL",
  LBL_Calculation: "LBL_Calculation",
  LBL_LessMPF: "LBL_LessMPF",
  LBL_System: "LBL_System",
  LBL_Manual: "LBL_Manual",
  LBL_StaffFixAlw: "LBL_StaffFixAlw",
  LBL_IncType: "LBL_IncType",
  LBL_IncSubType: "LBL_IncSubType",
  LBL_IsPayLeave: "LBL_IsPayLeave",
  LBL_DiscPay: "LBL_DiscPay",
  LBL_User: "LBL_User",
  LBL_IR56BRow: "LBL_IR56BRow",
  LBL_Prepaid: "LBL_Prepaid",
  LBL_NoPayLvs: "LBL_NoPayLvs",
  LBL_Error: "LBL_Error",
  LBL_UpdateTimeCard: "LBL_UpdateTimeCard",
  LBL_End: "LBL_End",
  LBL_CntClockIn: "LBL_CntClockIn",
  LBL_CntClockOut: "LBL_CntClockOut",
  LBL_ActClock: "LBL_ActClock",
  LBL_CntClock: "LBL_CntClock",
  LBL_Labor: "LBL_Labor",
  LBL_ShiftCodeSat: "LBL_ShiftCodeSat",
  LBL_ShiftCodeSun: "LBL_ShiftCodeSun",
  LBL_Formula: "LBL_Formula",
  LBL_HolidayType: "LBL_HolidayType",
  LBL_NumMax: "LBL_NumMax",
  LBL_AutoGen: "LBL_AutoGen",
  LBL_RosterPlanCode: "LBL_RosterPlanCode",
  LBL_EmployeeFile: "LBL_EmployeeFile",
  LBL_Employer: "LBL_Employer",
  LBL_HKID: "LBL_HKID",
  LBL_Sex: "LBL_Sex",
  LBL_MaritalStatus: "LBL_MaritalStatus",
  LBL_EmploymentPeriod: "LBL_EmploymentPeriod",
  LBL_LeavePay: "LBL_LeavePay",
  LBL_Mon: "LBL_Mon",
  LBL_Tue: "LBL_Tue",
  LBL_Wed: "LBL_Wed",
  LBL_Thu: "LBL_Thu",
  LBL_Fri: "LBL_Fri",
  LBL_Sat: "LBL_Sat",
  LBL_Sun: "LBL_Sun",
  LBL_Particulars: "LBL_Particulars",
  LBL_ACNum: "LBL_ACNum",
  LBL_Amt: "LBL_Amt",
  LBL_BankCode: "LBL_BankCode",
  LBL_TermsDays:"LBL_TermsDays",

  //MBL
  MBL_LocalOutdoorWork1: "MBL_LocalOutdoorWork1",
  MBL_LocalOutdoorWork2: "MBL_LocalOutdoorWork2",
  MBL_LocalOutdoorWork3: "MBL_LocalOutdoorWork3",
  MBL_BusinessTrip1: "MBL_BusinessTrip1",
  MBL_BusinessTrip2: "MBL_BusinessTrip2",
  MBL_CheckInOrOut: "MBL_CheckInOrOut",

  //CFM
  CFM_EnterEmail: "CFM_EnterEmail",
  CFM_Save: "CFM_Save",
  CFM_Reject: "CFM_Reject",
  CFM_Approve: "CFM_Approve",
  CFM_Leave: "CFM_Leave",
  CFM_FinishEvent: "CFM_FinishEvent",
  CFM_Cancel: "CFM_Cancel",
  //WARN
  WARN_Reject: "WARN_Reject",
  WARN_Approve: "WARN_Approve",
  WARN_IsRequired: "WARN_IsRequired",
  WARN_FromTimeCannotGreaterThanToTime: "WARN_FromTimeCannotGreaterThanToTime",
  WARN_Date: "WARN_Date",
  WARN_MaxOutdoorworkDays: "WARN_MaxOutdoorworkDays",
  WARN_Staff: "WARN_Staff",
  WARN_Type: "WARN_Type",
  WARN_DeleteEvent: "WARN_DeleteEvent",
  WARN_DeleteUser: "WARN_DeleteUser",
  WARN_DeleteType: "WARN_DeleteType",
  WARN_DeleteStaffGrade: "WARN_DeleteStaffGrade",
  WARN_DeleteAnnualLeavePlan: "WARN_DeleteAnnualLeavePlan",
  WARN_DeleteHoliday: "WARN_DeleteHoliday",
  WARN_DeleteWorkType: "WARN_DeleteWorkType",
  WARN_Delete: "WARN_Delete",
  WARN_Logout: "WARN_Logout",
  WARN_CheckIn: "WARN_CheckIn",
  WARN_CheckOut: "WARN_CheckOut",
  WARN_Confirm: "WARN_Confirm",
  WARN_SendEmail: "WARN_SendEmail",
  WARN_DaysOrHours: "WARN_DaysOrHours",
  WARN_Days: "WARN_Days",
  WARN_Hours: "WARN_Hours",
  WARN_HoursOutOfBound: "WARN_HoursOutOfBound",
  WARN_DaysOutOfBound: "WARN_DaysOutOfBound",
  WARN_Time: "WARN_Time",
  WARN_Reason: "WARN_Reason",
  WARN_IsDeleted: "WARN_IsDeleted",
  WARN_Invaild: "WARN_Invaild",
  WARN_OutOfBound100: "WARN_OutOfBound100",
  WARN_PhotoFileType: "WARN_PhotoFileType",
  WARN_PasswordNotMatch: "WARN_PasswordNotMatch",
  WARN_NotUpdated: "WARN_NotUpdated",
  WARN_DELETE: "WARN_Delete",
  WARN_UpdateEvent: "WARN_UpdateEvent",
  WARN_AllPassMustBeEntered: "WARN_AllPassMustBeEntered",
  WARN_AnnualLeavePlanRequired: "WARN_AnnualLeavePlanRequired",
  WARN_DeleteEmployeeType: "WARN_DeleteEmployeeType",
  WARN_DeleteJobPosition: "WARN_DeleteJobPosition",
  WARN_DeleteSourceOfApp: "WARN_DeleteSourceOfApp",
  WARN_DeleteAcademic: "WARN_DeleteAcademic",
  WARN_DeleteBenefit: "WARN_DeleteBenefit",
  WARN_SelectStaffGrade: "WARN_SelectStaffGrade",
  WARN_DeleteDocTemp: "WARN_DeleteDocTemp",
  WARN_SelectSysVar: "WARN_SelectSysVar",
  WARN_DeleteBank: "WARN_DeleteBank",
  WARN_DeleteDistrict: "WARN_DeleteDistrict",
  WARN_DeleteSkill: "WARN_DeleteSkill",
  WARN_DeleteStaff: "WARN_DeleteStaff",
  WARN_DeleteEmergencyContact: "WARN_DeleteEmergencyContact",
  WARN_DeleteAcademic: "WARN_DeleteAcademic",
  WARN_DeleteAttachment: "WARN_DeleteAttachment",
  WARN_DeleteJobHistory: "WARN_DeleteJobHistory",
  WARN_DeleteJobAd: "WARN_DeleteJobAd",
  WARN_SelectUser: "WARN_SelectUser",
  WARN_SelectInterview: "WARN_SelectInterview",
  WARN_AreYouSure: "WARN_AreYouSure",
  WARN_SubmitInterview: "WARN_SubmitInterview",
  WARN_FillInformation: "WARN_FillInformation",
  WARN_SubmitJobApplication: "WARN_SubmitJobApplication",
  WARN_SelectSearch: "WARN_SelectSearch",
  WARN_ToReject: "WARN_ToReject",
  WARN_ToMake: "WARN_ToMake",
  WARN_SelectOfferResult: "WARN_SelectOfferResult",
  WARN_SelectOneRecord: "WARN_SelectOneRecord",
  WARN_AreYouSureTo: "WARN_AreYouSureTo",
  WARN_SelectRating: "WARN_SelectRating",
  WARN_DeleteProbation: "WARN_DeleteProbation",
  WARN_AreYouSureTo: "WARN_AreYouSureTo",
  WARN_DeleteAttachment: "WARN_DeleteAttachment",
  WARN_DeleteCompany: "WARN_DeleteCompany",
  WARN_DeleteDocType: "WARN_DeleteDocType",
  WARN_ConfirmUpload: "WARN_ConfirmUpload",
  WARN_InsufficientBalance: "WARN_InsufficientBalance",
  WARN_LeaveScopeLimits: "WARN_LeaveScopeLimits",
  WARN_BLApplyAgain: "WARN_BLApplyAgain",
  //MENU
  MENU_Approval: "MENU_Approval",
  MENU_OutdoorWork: "MENU_OutdoorWork",
  MENU_LeaveApp: "MENU_LeaveApp",
  MENU_Report: "MENU_Report",
  MENU_StaffLeaveRecord: "MENU_StaffLeaveRecord",
  MENU_StaffAttendance: "MENU_StaffAttendance",
  MENU_MonthlyLeaveBalance: "MENU_MonthlyLeaveBalance",
  MENU_OutdoorWorkAllowance: "MENU_OutdoorWorkAllowance",
  MENU_TaxReturn: "MENU_TaxReturn",
  MENU_Administration: "MENU_Administration",
  MENU_UserList: "MENU_UserList",
  MENU_UserGrp: "MENU_UserGrp",
  MENU_UserGrpRights: "MENU_UserGrpRights",
  MENU_LeaveType: "MENU_LeaveType",
  MENU_MasterMaintenance: "MENU_MasterMaintenance",
  MENU_StaffGrading: "MENU_StaffGrading",
  MENU_AnnualLeavePlan: "MENU_AnnualLeavePlan",
  MENU_WorkType: "MENU_WorkType",
  MENU_Holiday: "MENU_Holiday",
  MENU_Employees: "MENU_Employees",
  MENU_Setup: "MENU_Setup",
  MENU_SyncFromMizar: "MENU_SyncFromMizar",
  MENU_SyncUsertoMizar: "MENU_SyncUsertoMizar",
  MENU_ShiftType: "MENU_ShiftType",
  MENU_Roster: "MENU_Roster",
  MENU_Location: "MENU_Location",
  MENU_RosterPlan: "MENU_RosterPlan",
  // MENU_AutopayFile: "MENU_AutopayFile",

  //MSG
  MSG_ReassignSubordinates: "MSG_ReassignSubordinates",
  MSG_ApplicationAdded: "MSG_ApplicationAdded",
  MSG_IsUpdated: "MSG_IsUpdated",
  MSG_Success: "MSG_Success",
  MSG_SelectDeleteRecord: "MSG_SelectDeleteRecord",
  MSG_Warning: "MSG_Warning",
  MSG_ValidationFailed: "MSG_ValidationFailed",
  MSG_RecordNotFound: "MSG_RecordNotFound",
  MSG_SelectEditRecord: "MSG_SelectEditRecord",
  MSG_SelectGrade: "MSG_SelectGrade",
  MSG_ValidEmail: "MSG_ValidEmail",
  MSG_AddOption: "MSG_AddOption",
  MSG_UpdateFail: "MSG_UpdateFail",
  MSG_SuccessJobApplication: "MSG_SuccessJobApplication",
  MSG_InterviewSubmit: "MSG_InterviewSubmit",
  MSG_InvalidToken: "MSG_InvalidToken",
  MSG_JobApplicationProcess: "MSG_JobApplicationProcess",
  MSG_SelectJobAd: "MSG_SelectJobAd",
  MSG_SelectCandidate: "MSG_SelectCandidate",
  MSG_CandidateExist: "MSG_CandidateExist",
  MSG_DateCompare: "MSG_DateCompare",
  MSG_ComfirmResign: "MSG_ComfirmResign",
  MSG_ExportFile: "MSG_ExportFile",
  MSG_ConfirmReApproval: "MSG_ConfirmReApproval",
  MSG_ConfirmUpdateLeave: "MSG_ConfirmUpdateLeave",
  MSG_CantChangeToSameLeaveType: "MSG_CantChangeToSameLeaveType",
  MSG_AlreadyExists: "MSG_AlreadyExists",
  MSG_AreSureUpdateTimeCard: "MSG_AreSureUpdateTimeCard",
  MSG_AreSureEndPayroll: "MSG_AreSureEndPayroll",
  MSG_StaffEmployHistoryDateTx: "MSG_StaffEmployHistoryDateTx",
  MSG_UpdateAttendance: "MSG_UpdateAttendance",
  MSG_InputLengthLimit: "MSG_InputLengthLimit",
  //TAB
  TAB_EmployeeType: "TAB_EmployeeType",
  TAB_EmployeeProfile: "TAB_EmployeeProfile",
  TAB_PersonalDetail: "TAB_PersonalDetail",
  TAB_Employment: "TAB_Employment",
  TAB_Benefit: "TAB_Benefit",
  TAB_StaffSkillsCerts: "TAB_StaffSkillsCerts",
  TAB_JobsHistory: "TAB_JobsHistory",
  TAB_Documents: "TAB_Documents",
  TAB_JobPosition: "TAB_JobPosition",
  TAB_Academic: "TAB_Academic",
  TAB_SourceOfApp: "TAB_SourceOfApp",
  TAB_BenefitPlan: "TAB_BenefitPlan",
  TAB_DocumentTemplate: "TAB_DocumentTemplate",
  TAB_Bank: "TAB_Bank",
  TAB_District: "TAB_District",
  TAB_SkillsCerts: "TAB_SkillsCerts",
  TAB_ProposeInterviewSchedule: "TAB_ProposeInterviewSchedule",
  TAB_Attachment: "TAB_Attachment",
  TAB_Letters: "TAB_Letters",
  TAB_Probation: "TAB_Probation",
  TAB_Company: "TAB_Company",
  TAB_DocType: "TAB_DocType"
};
export default SysMsgDict;



// WEBPACK FOOTER //
// ./src/constants/SysMsgDict.js